import Button from '@mui/material/Button';
import Drawer from '@mui/material/Drawer';
import Stack from '@mui/material/Stack';
import React from 'react';
import {useSupportSlotDefinitionCreateDrawerState} from '../state/support-slot-definition-create-drawer-state';
import {UniversalInput} from '../../shared/UniversalInput';
import { Checkbox, FormControlLabel } from '@mui/material';

type Props = {
  isDrawerOpen: boolean
  onDrawerClosed: () => void
  weekday: number
  refreshSlotDefinitions: () => Promise<void>
}

const days = ["Poniedziałek", "Wtorek", "Środa", "Czwartek", "Piątek", "Sobota", "Niedziela"];

export const SupportSlotDefinitionCreateDrawer = ({weekday, refreshSlotDefinitions, isDrawerOpen, onDrawerClosed}: Props) => {
  const state = useSupportSlotDefinitionCreateDrawerState(weekday)

  const buildStartTime = () => <UniversalInput
    label="Godzina rozpoczecia slotu"
    type="time"
    value={state.slotDefinition.startTime}
    onChange={(val) => state.setSlotDefinition({...state.slotDefinition, startTime: val as string})}
    min={0}
    step={1}
  />

  const buildEndTime = () => <UniversalInput
    label="Godzina zakończenia slotu"
    type="time"
    value={state.slotDefinition.endTime}
    onChange={(val) => state.setSlotDefinition({...state.slotDefinition, endTime: val as string})}
    min={0}
    step={1}
  />

  const buildValidFrom = () => <UniversalInput
    label="Aktywny od"
    type="date"
    value={state.slotDefinition.validFrom}
    onChange={(val) => state.setSlotDefinition({...state.slotDefinition, validFrom: val as string})}
    min={0}
    step={1}
  />

  const buildValidTo = () => <UniversalInput
    label="Aktywny do"
    type="date"
    value={state.slotDefinition.validTo}
    onChange={(val) => state.setSlotDefinition({...state.slotDefinition, validTo: val as string})}
    min={0}
    step={1}
  />

  const buildIsGlobal = () => <FormControlLabel
    control={
      <Checkbox
        checked={state.slotDefinition.isGlobal}
        onChange={(e) => state.setSlotDefinition({...state.slotDefinition, isGlobal: e.target.checked})}
      />
    }
    label={'Slot globalny (zawsze widoczny dla wszystkich firm)'}
  />

  return <Drawer
    anchor="right"
    open={isDrawerOpen}
    onClose={onDrawerClosed}
    PaperProps={{
      sx: {
        width: 480,
        marginTop: '34px',
        height: `calc(100%)`,
        position: 'fixed',
        right: 0,
        padding: 3,
        overflowY: 'auto',
      }
    }}
  >
    <h2>Nowy slot: {days[weekday - 1]}</h2>
    <form onSubmit={async (event) => {
      event.preventDefault();
      await state.handleSubmit()
      await refreshSlotDefinitions()
      onDrawerClosed()
    }}>
      <Stack spacing={3}>
        {buildStartTime()}
        {buildEndTime()}
        {buildValidFrom()}
        {buildValidTo()}
        {/*{buildIsGlobal()}*/}
        <Button type="submit" variant="contained" color="primary">
          {state.translate('common.save.title')}
        </Button>
        <Button variant="outlined" onClick={onDrawerClosed}>
          {state.translate('common.cancel.title')}
        </Button>
      </Stack>
    </form>
  </Drawer>
}